import React from "react";
import { Column, Columns, Table } from "@allxsmith/bestax-bulma";
import PrintPartList from "./PrintPartList";

const RETURNS_TCS = "Returns: You have 14 days from delivery to return items under the Consumer Contracts Regulations 2013 - unused, in original packaging, with proof of purchase. Change of mind: return postage is at your expense; faulty or incorrect items: we cover return postage. Report faults within 48 hours of delivery with photographs. Non-returnable items (marked * above): fitted electrical components, fluids and lubricants, and any item fitted or modified to a vehicle. Refunds are made to the original payment method within 14 days. Vehicle compatibility is the customer's responsibility - check your reg/VIN before ordering. Full terms & returns policy: maxuspartsdirect.co.uk/terms-and-conditions and /returns-and-exchanges.";



class PrintQuote extends React.Component {

    PartRow(part){
        return (
            <tr>
                <td>{part.name}{part.non_returnable ? " *" : ""}</td>
                <td>{part.part_number}</td>
                <td>{part.supplier ? part.supplier.display_name : ""}</td>
                <td>£{(Math.round(part.customer_cost * 100 +Number.EPSILON) / 100) ?? 0}</td>
            </tr>
        )
    }


    render() {
        const partOrder = this.props.data;
        const parts = partOrder.parts;
        let totalCustomerCost = partOrder.total_part_customer_charge;
        let totalCustomerCostVat = partOrder.total_part_customer_charge_inc_vat

        // if(parts.length > 0){
        //     parts.forEach(part => {
        //         totalCustomerCost += part.customer_cost
        //     })
        // }

        return (
            <div className={"print-landscape"}>
                <Columns isMultiline>
                  <div style={{width: '100%'}}>
                    <h1 style={{fontSize: '20px', fontWeight: 'bold', margin: 0}}>Van Parts Direct Ltd</h1>
                    <h2 className="job-card-print-title">{`${partOrder && partOrder.status === "QUOTE" ? "Quote" : "Part Order"} - ${partOrder ? partOrder.id : ""}`}</h2>
                  </div>
                </Columns>
                <br/>
                <Columns className={"page-break"} isMultiline>
                    <Column>
                        <div>
                            <Table isBordered>
                                <thead>
                                  <tr>
                                    <th>Customer</th>
                                    <th>Customer Vehicle</th>
                                    <th>Customer Order Number</th>
                                    <th>Total Customer Cost</th>
                                    <th>Total Customer Cost (Inc VAT)</th>
                                  </tr>
                                </thead>
                                <tr>
                                  <td data-testid={"customer"}>{partOrder.customer ? partOrder.customer.display_name : ""}</td>
                                  <td data-testid={"customer-vehicle"}>{partOrder.customer_vehicle}</td>
                                  <td data-testid={"order-number"}>{partOrder.order_number}</td>
                                  <td data-testid={"total-customer-cost"}>{`£${totalCustomerCost}`}</td>
                                  <td data-testid={"total-customer-cost-vat"}>{`£${totalCustomerCostVat}`}</td>
                                </tr>
                            </Table>
                            <Table
                                isBordered
                            >
                                <thead>
                                    <tr>
                                        <th>Part Name</th>
                                        <th>Part Number</th>
                                        <th>Part Supplier</th>
                                        <th>Customer Charge</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {parts.map(part => this.PartRow(part))}
                                </tbody>
                            </Table>
                        </div>
                    </Column>
                </Columns>
                <div style={{fontSize: '10px', color: '#444', marginTop: '10px', borderTop: '1px solid #ccc', paddingTop: '6px'}}>
                    {RETURNS_TCS}
                </div>
            </div>
        );
    }

}
export default PrintQuote